import axios from 'axios';
import { Store } from '../../store';
import interceptor from './interceptor/AuthInterceptor';

const createAxiosInstance = () => {
    let instance = axios.create({
        baseURL: '',
        headers: {
            post: { Accept: 'application/json' },
        },
    });
    instance.interceptors.response.use(undefined, interceptor(instance));
    return instance;
};

const BaseRequest = () => {
    const _axiosInst = createAxiosInstance();

    return {
        axiosInst: _axiosInst,

        async getPublicCredentials() {
            let req = await _axiosInst.post(`/oauth/token`, {
                grant_type: 'client_credentials',
                client_id: params.client_id,
                client_secret: params.client_secret,
                scope: '',
            });
            return await req.data;
        },

        language() {
            let language = localStorage.getItem('i18nextLng');
            let lang;
            switch (language) {
                case 'en':
                    lang = 5;
                    break;
                case 'es':
                    lang = 3;
                    break;
                default:
                    lang = 1;
                    break;
            }
            return lang;
        },

        publicHeaders() {
            return {
                lang: this.language(),
            };
        },

        privateHeaders() {
            let state = Store.getState();
            
            let privateCredentials = state.auth.credentials
                ? state.auth.credentials
                : state.authPersist.credentials;


            if (!privateCredentials) {
                try {
                    //const authData = localStorage.getItem('auth');
                    const authPersistData = localStorage.getItem('persist:auth');
                    //console.log('LocalStorage auth:', authData);
                    //console.log('LocalStorage persist:auth:', authPersistData);
                    
                    if (authPersistData) {
                        const parsed = JSON.parse(authPersistData);
                        if (parsed.credentials && parsed.credentials !== 'false') {
                            const credentials = JSON.parse(parsed.credentials);
                            console.log('Found credentials in localStorage:', credentials);
                            privateCredentials = credentials;
                        }
                    }
                } catch (e) {
                    console.log('Error reading from localStorage:', e);
                }
            }

            if (!privateCredentials) {
                return { lang: this.language() };
            }

            return {
                lang: this.language(),
                Authorization: `Bearer ${privateCredentials.token}`,
            };
        },

        privateOrPublicHeaders() {
            let state = Store.getState();
            
            let privateCredentials = state.auth.credentials
                ? state.auth.credentials
                : state.authPersist.credentials;

            let auth = privateCredentials
                ? { Authorization: `Bearer ${privateCredentials.token}` }
                : {};

            return {
                lang: this.language(),
                ...auth,
            };
        },

        async refreshToken() {
            let state = Store.getState();

            let privateCredentials =
                state.auth.credentials || state.authPersist.credentials;

            let req = await _axiosInst.post(`/oauth/token`, {
                grant_type: 'refresh_token',
                client_id: process.env.REACT_APP_PASSWORD_CLIENT_ID,
                client_secret: process.env.REACT_APP_PASSWORD_CLIENT_SECRET,
                scope: '',
                refresh_token: privateCredentials.refresh,
            });
            return await req.data;
        },

        toQueryString(params) {
            const u = new URLSearchParams();
            Object.entries(params).forEach((p) => {
                u.append(p[0], p[1]);
            });
            return u.toString();
        },
    };
};

export default BaseRequest();

